import React from 'react';
import styled from 'styled-components';

export const TitleHeader = ({ title }: TitleHeaderProps) => (
	<TitleHeaderContainer>
		<TitleHeaderPart></TitleHeaderPart>
		<TitleHeaderPart center={true}>{title}</TitleHeaderPart>
		<TitleHeaderPart></TitleHeaderPart>
	</TitleHeaderContainer>
);

interface TitleHeaderProps {
	title: string;
}

const TitleHeaderContainer = styled.div`
	display: flex;
	width: 100%;
	padding: 10px;
	background-color: ${({ theme }) => theme.colors.darkR};
	font-size: 16px;
	color: ${({ theme }) => theme.colors.white};
`;

const TitleHeaderPart = styled.div<{ center?: boolean }>`
	flex: 1;

	${({ center }) => center && 'flex: 4; text-align: center;'}
`;
